/* unplugin-vue-components disabled */import script from "./GoodsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsDetails.vue?vue&type=script&setup=true&lang=js"

import "./GoodsDetails.vue?vue&type=style&index=0&id=357f62e0&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357f62e0"]])

export default __exports__